export const useWindowWidth = () => {
    const currentWindowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    return { currentWindowWidth };
};
